.preview-container {
    height: calc(100% - 62px);
}
